export const setLocalStorage = async (key: string, value: any) => {
  try {
    await localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error("Error setting from localStorage:", error);
    return false;
  }
};
